module.exports = {
  blogHomeTitle: 'Space Planning FAQs',

  //blog title Intro
  blogTitleIntro: "Planning your next office? Start here. These articles answer the questions we hear most often — from how to calculate your space needs to what all those square footage terms actually mean.",

  // blog tags
  blogTagAllArticles: 'All Articles',
  blogTagSizeAndFit: 'Size & Fit',
  blogTagOfficeCulture: 'Office Culture',
  blogTagSpaceAndDesign: 'Space & Design',
  blogTagWorkplaceTrends: 'Workplace Trends'
};
